export type ProductElementOrderItem = string | string[];

export const DEFAULT_PRODUCT_ELEMENT_ORDER: ProductElementOrderItem[] = [
  'image',
  'conditionBadge',
  'rating',
  'title',
  'specs',
  'price',
  'brand',
  'savingsBadge',
  'description',
  'button',
];

export function flattenProductElementOrder(order: ProductElementOrderItem[]): string[] {
  return order.flatMap((item) => (Array.isArray(item) ? item : [item]));
}

export function resolveProductElementOrder(settings: {
  element_order?: ProductElementOrderItem[];
  elementOrder?: ProductElementOrderItem[];
  brandPosition?: 'above_price' | 'beside_price';
}): ProductElementOrderItem[] {
  const saved = Array.isArray(settings.element_order) && settings.element_order.length > 0
    ? settings.element_order
    : (Array.isArray(settings.elementOrder) && settings.elementOrder.length > 0 ? settings.elementOrder : null);

  let base = saved || DEFAULT_PRODUCT_ELEMENT_ORDER;
  let flat = flattenProductElementOrder(base);

  // "specs" was added after many pages already saved their order — slot it in right after the
  // title so the editor lists it (hidden until showSpecs is switched on) instead of the merchant
  // having no row to enable.
  if (!flat.includes('specs')) {
    const titleIdx = base.findIndex((item) => (Array.isArray(item) ? item.includes('title') : item === 'title'));
    base = titleIdx >= 0
      ? [...base.slice(0, titleIdx + 1), 'specs', ...base.slice(titleIdx + 1)]
      : [...base, 'specs'];
    flat = flattenProductElementOrder(base);
  }

  if (!flat.includes('brand') && settings.brandPosition === 'beside_price') {
    return base.map((item) => (item === 'price' ? ['price', 'brand'] : item));
  }

  return base;
}

export function getRowId(item: ProductElementOrderItem): string {
  return Array.isArray(item) ? `group:${item.join('+')}` : item;
}
